<template>
  <div class="found">
    <div class="found-popup">
      <div class="found-message">
        {{ $l.tourismFound }}
      </div>

      <div class="group">
        <div class="label">
          ポイント名
        </div>

        <div>
          {{ tourism.get('name') }}
        </div>
      </div>

      <div class="group">
        <div class="label">
          URL
        </div>

        <div>
          <a href="tourism.get('url')">{{ tourism.get('url') }}</a>
        </div>
      </div>

      <div class="group">
        <div class="label">
          説明
        </div>

        <div>
          {{ tourism.get('description') }}
        </div>
      </div>

      <button-hide :action="hide" padding="s">
        {{ $l.close }}
      </button-hide>
    </div>
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import ButtonHide from '@/components/Button'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    ButtonHide
  },

  computed: {
    tourism: function () {
      return this.$store.state.tourism.tourism
    }
  },

  methods: {
    hide: function () {
      this.$store.dispatch('popupTourism/hide', null)
    }
  }
}
</script>

<style lang="scss" scoped>
.found {
  display: flex;
  justify-content: center;
  &-popup {
    padding: 10px;
    border-radius: 4px;
    background: white;
    width: 90vw;
    max-height: 90vh;
    overflow-y: auto;
    box-sizing: border-box;
  }

  &-message {
    text-align: center;
    font-size: 1.2em;
    font-weight: bold;
    margin-bottom: 10px;
  }
}

.label {
  font-weight: bold;
}

.group {
  padding: 10px;
}
</style>
